@if(visible()){
<p class="jk-row-border">

<!-- <dx-file-uploader [selectButtonText]="selectButtonText"
[labelText]="labelText" [accept]="accept"
[uploadMode]="uploadMode" [allowedFileExtensions]="allowedFileExtensions" [minFileSize]="minFileSize"
[uploadMethod]="uploadMethod" [maxFileSize]="maxFileSize" [multiple]="false" [uploadUrl]="uploadUrl"
[(value)]="value" (onValueChanged)="onValueChange($event.value)"

[uploadFile]="uploadFile">
</dx-file-uploader> -->
</p>
}



<!-- @if (visible()) {
<ion-col>
  <ion-row class="jk-row-border">
    <dx-file-uploader [selectButtonText]="selectButtonText"
      [labelText]="labelText" [accept]="accept"
      [uploadMode]="uploadMode" [allowedFileExtensions]="allowedFileExtensions" [minFileSize]="minFileSize"
      [uploadMethod]="uploadMethod" [maxFileSize]="maxFileSize" [multiple]="false" [uploadUrl]="uploadUrl"
      [(value)]="value" (onValueChanged)="onValueChange($event.value)"

      [uploadFile]="uploadFile">
    </dx-file-uploader>
  </ion-row>
</ion-col>
} -->
